import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Ticket } from 'src/app/models';
import { PatronColors } from '@teorema/patron';
import { CustomerService, TcDataService, TcTicketService } from 'src/app/shared/services';
import { TicketIaClipboardService } from '../../../services/ticket-ia-clipboard.service';

@Component({
  selector: 'ticket-show-header',
  templateUrl: './ticket-show-header.component.html',
  styleUrls: ['./ticket-show-header.component.scss'],
  standalone: false,
})
export class TicketShowHeaderComponent implements OnInit {
  @Input() entity?: Ticket;
  @Input() isSaving?: boolean;
  @Input() showSaveButton?: boolean;
  @Input() popoverBaseZIndex: number = 0;
  @Input() popoverAppendTo: any = 'body';

  @Output() save = new EventEmitter<any>();

  constructor(
    public customerService: CustomerService,
    private dataService: TcDataService,
    public ticketService: TcTicketService,
    private ticketIaClipboardService: TicketIaClipboardService
  ) {}

  ngOnInit(): void {}

  getStatusClass(status: any) {
    return this.dataService.getTicketStatusClass(status);
  }

  isDelayed() {
    return this.dataService.isDelayed(this.ticketService.getExpectedDate({ ticket: this.entity }));
  }

  copyIaContext() {
    if (!this.entity) {
      return;
    }

    this.ticketIaClipboardService.copy(this.entity);
  }

  getExpectedDateColor(expectedDate?: string | Date | null): PatronColors {
    if (!expectedDate) return 'secondary';

    const expected = new Date(expectedDate);
    if (isNaN(expected.getTime())) return 'secondary';

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const normalizedExpected = new Date(expected);
    normalizedExpected.setHours(0, 0, 0, 0);

    const diffInDays = (normalizedExpected.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);

    if (diffInDays > 1) return 'success';
    if (diffInDays >= 0) return 'warning';
    return 'danger';
  }
}
